import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSelfieGlyphSecondary from './svgs/SelfieGlyphSecondary.js';
import SvgSelfieGlyph from './svgs/SelfieGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var selfieGlyph = (props => useIcon(SvgSelfieGlyph, SvgSelfieGlyphSecondary, props));

export { selfieGlyph as default };
